package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable

@Serializable
open class SignSymptomSettingTriggeredWorsenedBy(var id: String? = null){
	var settingId: String? = null
	var associatedFactorId: String? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as SignSymptomSettingTriggeredWorsenedBy
		if (id != other.id) return false
		if (settingId != other.settingId) return false
		if (associatedFactorId != other.associatedFactorId) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (settingId?.hashCode() ?: 0)
		result = 31 * result + (associatedFactorId?.hashCode() ?: 0)
		return result
	}

}
